var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},_vm._l((_vm.listHonors),function(item,index){return _c('div',{key:index,staticClass:"card-staff"},[_c('CardStaffItem',{attrs:{"staff":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }